import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { TextcontentModel } from './textcontent.model';

export class MessageorderModel extends BaseModel implements Deserializable {

  // columns
  title: string;
  active: boolean;
  type: string;
  context: string;
  description?: string;
  conditions?: {
    templates?: Array<number>,
    businessunits?: Array<number>,
    recommendations?: Array<number>
    afterreport?: boolean
  };
  recipients?: { [key: string]: boolean };
  emails?: Array<string>;
  options?: { [key: string]: boolean };

  // relations
  contents: Array<TextcontentModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // contents
    const contents = [];
    if (this.contents !== null && this.contents !== undefined) {
      this.contents.forEach((content: TextcontentModel) => {
        contents.push(new TextcontentModel().deserialize(content));
      });
    }
    this.contents = contents;
    return this;
  }

  public get language_list(): string {
    return this.contents.map((content: TextcontentModel) => {
      return content?.language?.key;
    }).join(' | ');
  }

}
